import React, { useState } from 'react';
import {Divider, Modal, Segment, Item, Icon} from 'semantic-ui-react';
import {Link} from "react-router-dom";


function ContactModal( props ) {
  // State to control the visibility of the modal
  const [open, setOpen] = useState(false);

  return (
    <div>
        <Item as={Link} style={{
            color: props.color,
            fontSize: props.fontsize,
            fontWeight: props.weight


        }} onClick={() => setOpen(true)}>
            Contact
        </Item>


        {/* Modal Definition */}
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        size='small'
        style={{borderRadius: '10px'}}
      >
          <Segment textAlign='center' vertical style={{paddingTop: '7em', paddingBottom: '6em', borderRadius: '30px'}}>
          <Modal.Header style={{padding: 0}}>
              {/* Close Button */}
              <Icon
                  name="close"
                  style={{
                      position: 'absolute',
                      top: '10px',
                      right: '10px',
                      float: 'right',
                      cursor: 'pointer',
                      color: 'black',
                  }}
                  onClick={() => setOpen(false)}
              />
          </Modal.Header>

          <Modal.Content style={{borderRadius: '30px'}}>
                  <h3 style={{fontSize: '2em', paddingBottom: '0.7em'}}>Manouk van Egmond</h3>
                  <Divider
                      style = {{height: '3px', borderRadius: '3px', background: 'var(--right-1)'}}
                  />
                  <br/>
                  <p style={{fontSize: '1.33em'}}><a href='mailto:manouk.vanegmond@gmail.com' style={{color: 'black', textDecoration: 'underline'}}>manouk.vanegmond@gmail.com</a></p>
          </Modal.Content>
          </Segment>
      </Modal>
    </div>
  );
}

export default ContactModal;
